import { useMutation } from "@tanstack/react-query";
import exchangeStytchToken from "../requests/exchangeStytchToken";
export default function useExchangeStytchToken() {
    const mutation = useMutation({
        mutationFn: async (input) => {
            return await exchangeStytchToken(input.stytchToken, input.identifierType, input.identifier, input.sessionName, input.sessionType, input.now ?? new Date());
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useExchangeStytchToken.js.map